// Constantes estáticas utilizadas por NatalChartScreen.
// Este archivo no contiene hooks, estado ni lógica de React.
import { isEnglishPresentation } from '../../localization/presentationLanguage';

const SIGN_EN = Object.freeze({
  Aries: 'Aries', Taurus: 'Taurus', Gemini: 'Gemini', Cancer: 'Cancer', Leo: 'Leo', Virgo: 'Virgo',
  Libra: 'Libra', Scorpio: 'Scorpio', Sagittarius: 'Sagittarius', Capricorn: 'Capricorn', Aquarius: 'Aquarius', Pisces: 'Pisces',
});

const PLANET_EN = Object.freeze({
  Sun: 'Sun', Moon: 'Moon', Mercury: 'Mercury', Venus: 'Venus', Mars: 'Mars', Jupiter: 'Jupiter', Saturn: 'Saturn',
  Uranus: 'Uranus', Neptune: 'Neptune', Pluto: 'Pluto', Ascendant: 'Ascendant', Descendant: 'Descendant',
  MC: 'Midheaven', IC: 'Imum Coeli', Lilith: 'Lilith', 'Mean Node': 'Mean Node', 'True Node': 'True Node',
  'North Node': 'North Node', 'South Node': 'South Node', Chiron: 'Chiron', Ceres: 'Ceres', Vesta: 'Vesta', Juno: 'Juno', Pallas: 'Pallas',
});

export const ASPECT_EN = Object.freeze({ conjunction: 'Conjunction', sextile: 'Sextile', square: 'Square', trine: 'Trine', opposition: 'Opposition' });
export const ASPECT_NATURE_EN = Object.freeze({ soft: 'Harmonious', hard: 'Tense', tense: 'Tense', awkward: 'Challenging', neutral: 'Neutral' });

export const SIGN_ES = {
  Aries: 'Aries',
  Taurus: 'Tauro',
  Gemini: 'Géminis',
  Cancer: 'Cáncer',
  Leo: 'Leo',
  Virgo: 'Virgo',
  Libra: 'Libra',
  Scorpio: 'Escorpio',
  Sagittarius: 'Sagitario',
  Capricorn: 'Capricornio',
  Aquarius: 'Acuario',
  Pisces: 'Piscis',
};

export const SIGN_EMOJI = {
  Aries: '♈',
  Taurus: '♉',
  Gemini: '♊',
  Cancer: '♋',
  Leo: '♌',
  Virgo: '♍',
  Libra: '♎',
  Scorpio: '♏',
  Sagittarius: '♐',
  Capricorn: '♑',
  Aquarius: '♒',
  Pisces: '♓',
};

export const PLANET_ES = {
  Sun: 'Sol',
  Moon: 'Luna',
  Mercury: 'Mercurio',
  Venus: 'Venus',
  Mars: 'Marte',
  Jupiter: 'Júpiter',
  Saturn: 'Saturno',
  Uranus: 'Urano',
  Neptune: 'Neptuno',
  Pluto: 'Plutón',

  // Puntos y asteroides que suelen venir del API
  Ascendant: 'Ascendente',
  Descendant: 'Descendente',
  MC: 'Medio Cielo',
  IC: 'Fondo del Cielo',
  Lilith: 'Lilith',
  'Mean Node': 'Nodo Medio',
  'True Node': 'Nodo Verdadero',
  'North Node': 'Nodo Norte',
  'South Node': 'Nodo Sur',
  Chiron: 'Quirón',
  Ceres: 'Ceres',
  Vesta: 'Vesta',
  Juno: 'Juno',
  Pallas: 'Palas',
};

export const PLANET_EMOJI = {
  Sun: '☀️',
  Moon: '🌙',
  Mercury: '☿',
  Venus: '♀',
  Mars: '♂',
  Jupiter: '♃',
  Saturn: '♄',
  Uranus: '♅',
  Neptune: '♆',
  Pluto: '♇',
  Ascendant: '↗',
  Descendant: '↘',
  MC: '🜁',
  IC: '🜃',
  Lilith: '⚸',
  'Mean Node': '☊',
  'True Node': '☊',
  'North Node': '☊',
  'South Node': '☋',
  Chiron: '⚷',
  Ceres: '⚳',
  Vesta: '⚶',
  Juno: '⚵',
  Pallas: '⚴',
};

export const ASPECT_ES = {
  conjunction: 'Conjunción',
  sextile: 'Sextil',
  square: 'Cuadratura',
  trine: 'Trígono',
  opposition: 'Oposición',
};

export const ASPECT_SYMBOL = {
  conjunction: '☌',
  sextile: '⚹',
  square: '□',
  trine: '△',
  opposition: '☍',
};

export const ASPECT_NATURE_ES = {
  soft: 'Armónico',
  hard: 'Tenso',
  tense: 'Tenso',
  awkward: 'Desafiante',
  neutral: 'Neutro',
};

export const SHARED_CHIP_STYLE = {
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(255,255,255,0.10)',
  color: '#F4E7BF',
  padding: '4px 8px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 800,
  opacity: 0.96,
};

export const PLANET_MEANING_ES = {
  Sun: 'Identidad, propósito y voluntad. Cómo brillás y afirmás tu presencia.',
  Moon: 'Emociones, necesidades internas y seguridad. Cómo sentís y reaccionás.',
  Mercury: 'Mente, comunicación y aprendizaje. Cómo pensás, hablás y decidís.',
  Venus: 'Afecto, placer y valores. Cómo amás, qué te atrae y qué priorizás.',
  Mars: 'Impulso, deseo y acción. Cómo actuás, competís y ponés límites.',
  Jupiter: 'Expansión y fe. Dónde creces, enseñás y encontrás sentido.',
  Saturn: 'Responsabilidad y estructura. Dónde madurás, te exigís y construís.',
  Uranus: 'Cambio e independencia. Dónde rompés moldes y buscás libertad.',
  Neptune: 'Inspiración e intuición. Dónde soñás, idealizás y te sensibilizás.',
  Pluto: 'Transformación y poder interno. Dónde renacés y vas a lo profundo.',
  Ascendant: 'Tu “máscara” social y primer impacto. Cómo te ven al conocerte.',
  Descendant: 'Vínculos y parejas. Qué buscás/activás en el otro.',
  MC: 'Vocación e imagen pública. Dónde querés llegar y cómo te reconocen.',
  IC: 'Raíces y mundo íntimo. Dónde te sentís en casa y te recargás.',
  Lilith: 'Instinto y sombra. Deseos crudos y límites personales.',
  'Mean Node': 'Dirección evolutiva. Aprendizajes kármicos y crecimiento.',
  'True Node': 'Dirección evolutiva. Aprendizajes kármicos y crecimiento.',
  Chiron: 'Herida y sanación. Lo que duele pero te vuelve guía.',
  Ceres: 'Nutrición y cuidado. Cómo cuidás y qué necesitás para sostenerte.',
  Vesta: 'Foco y devoción. Dónde te comprometés con disciplina.',
  Juno: 'Compromiso y acuerdos. Cómo buscás lealtad y pactos.',
  Pallas: 'Estrategia y visión. Cómo resolvés y ves patrones.',
};

export const PLANET_MEANING_EN = {
  Sun: 'Identity, purpose, and will. How you shine and assert your presence.', Moon: 'Emotions, inner needs, and security. How you feel and react.',
  Mercury: 'Mind, communication, and learning. How you think, speak, and decide.', Venus: 'Affection, pleasure, and values. How you love, what attracts you, and what you prioritize.',
  Mars: 'Drive, desire, and action. How you act, compete, and set boundaries.', Jupiter: 'Expansion and faith. Where you grow, teach, and find meaning.',
  Saturn: 'Responsibility and structure. Where you mature, challenge yourself, and build.', Uranus: 'Change and independence. Where you break patterns and seek freedom.',
  Neptune: 'Inspiration and intuition. Where you dream, idealize, and become sensitive.', Pluto: 'Transformation and inner power. Where you are reborn and go deep.',
  Ascendant: 'Your social mask and first impression. How others see you when you meet.', Descendant: 'Relationships and partners. What you seek and activate in others.',
  MC: 'Vocation and public image. Where you want to go and how you gain recognition.', IC: 'Roots and inner life. Where you feel at home and recharge.',
  Lilith: 'Instinct and shadow. Raw desires and personal boundaries.', 'Mean Node': 'Evolutionary direction. Karmic lessons and growth.',
  'True Node': 'Evolutionary direction. Karmic lessons and growth.', Chiron: 'Wound and healing. What hurts but can turn you into a guide.',
  Ceres: 'Nurturing and care. How you care and what sustains you.', Vesta: 'Focus and devotion. Where you commit with discipline.',
  Juno: 'Commitment and agreements. How you seek loyalty and partnership.', Pallas: 'Strategy and vision. How you solve problems and recognize patterns.',
};

export const HOUSE_MEANING_ES = {
  1: 'Identidad, cuerpo, presencia, comienzo de ciclos.',
  2: 'Recursos, dinero, autoestima y valores personales.',
  3: 'Comunicación, mente cotidiana, hermanos, entorno cercano.',
  4: 'Hogar, familia, raíces, intimidad emocional.',
  5: 'Creatividad, romance, disfrute, expresión personal.',
  6: 'Rutina, trabajo diario, salud, hábitos y servicio.',
  7: 'Parejas, sociedades, acuerdos y espejo del otro.',
  8: 'Transformación, sexualidad, recursos compartidos, profundidad.',
  9: 'Filosofía, estudios, viajes, sentido y visión de vida.',
  10: 'Vocación, carrera, metas, reputación e impacto.',
  11: 'Amigos, redes, comunidad, proyectos a futuro.',
  12: 'Inconsciente, retiro, espiritualidad, cierres y sanación.',
};

export const HOUSE_MEANING_EN = {
  1: 'Identity, body, presence, and new beginnings.', 2: 'Resources, money, self-worth, and personal values.',
  3: 'Communication, everyday thinking, siblings, and the local environment.', 4: 'Home, family, roots, and emotional intimacy.',
  5: 'Creativity, romance, enjoyment, and self-expression.', 6: 'Routine, daily work, health, habits, and service.',
  7: 'Partners, associations, agreements, and the mirror of others.', 8: 'Transformation, sexuality, shared resources, and depth.',
  9: 'Philosophy, study, travel, meaning, and worldview.', 10: 'Vocation, career, goals, reputation, and impact.',
  11: 'Friends, networks, community, and future projects.', 12: 'The unconscious, retreat, spirituality, endings, and healing.',
};

export const HOUSE_EMOJI = {
  1: '🏛',
  2: '🏛',
  3: '🏛',
  4: '🏛',
  5: '🏛',
  6: '🏛',
  7: '🏛',
  8: '🏛',
  9: '🏛',
  10: '🏛',
  11: '🏛',
  12: '🏛'
};

export const SIGN_TONE_ES = {
  Aries: 'con impulso y valentía',
  Taurus: 'con constancia y disfrute sensorial',
  Gemini: 'con curiosidad y mente rápida',
  Cancer: 'con sensibilidad y protección',
  Leo: 'con orgullo y corazón creativo',
  Virgo: 'con detalle y sentido práctico',
  Libra: 'con equilibrio y diplomacia',
  Scorpio: 'con intensidad y profundidad',
  Sagittarius: 'con expansión y búsqueda de verdad',
  Capricorn: 'con ambición y disciplina',
  Aquarius: 'con originalidad y visión colectiva',
  Pisces: 'con intuición y empatía',
};

export const SIGN_TONE_EN = {
  Aries: 'with drive and courage', Taurus: 'with consistency and sensual enjoyment', Gemini: 'with curiosity and a quick mind',
  Cancer: 'with sensitivity and protectiveness', Leo: 'with pride and a creative heart', Virgo: 'with attention to detail and practicality',
  Libra: 'with balance and diplomacy', Scorpio: 'with intensity and depth', Sagittarius: 'with expansion and a search for truth',
  Capricorn: 'with ambition and discipline', Aquarius: 'with originality and collective vision', Pisces: 'with intuition and empathy',
};

export const GEO_ALIAS_PRESETS = [
  {
    country: 'AR',
    province: 'CABA',
    city: 'Capital Federal',
    lat: -34.6037,
    lon: -58.3816,
    tzOffsetMin: -180,
    timezone: 'America/Argentina/Buenos_Aires',
    place: 'Capital Federal, CABA (Capital Federal), Argentina',
    aliases: [
      'capital federal',
      'caba',
      'ciudad autonoma de buenos aires',
      'ciudad autónoma de buenos aires',
      'buenos aires',
      'capital federal, caba',
      'caba capital federal',
    ],
  },
];

export const GEO = {
  AR: {
    label: 'Argentina',
    provinces: {
      CABA: {
        label: 'CABA (Capital Federal)',
        cities: {
          'Capital Federal': {
            label: 'Capital Federal',
            lat: -34.6037,
            lon: -58.3816,
          },
        },
      },
      'Buenos Aires': { label: 'Buenos Aires (Provincia)', cities: {} },
      Catamarca: { label: 'Catamarca', cities: {} },
      Chaco: { label: 'Chaco', cities: {} },
      Chubut: { label: 'Chubut', cities: {} },
      Córdoba: { label: 'Córdoba', cities: {} },
      Corrientes: { label: 'Corrientes', cities: {} },
      'Entre Ríos': { label: 'Entre Ríos', cities: {} },
      Formosa: { label: 'Formosa', cities: {} },
      Jujuy: { label: 'Jujuy', cities: {} },
      'La Pampa': { label: 'La Pampa', cities: {} },
      'La Rioja': { label: 'La Rioja', cities: {} },
      Mendoza: { label: 'Mendoza', cities: {} },
      Misiones: { label: 'Misiones', cities: {} },
      Neuquén: { label: 'Neuquén', cities: {} },
      'Río Negro': { label: 'Río Negro', cities: {} },
      Salta: { label: 'Salta', cities: {} },
      'San Juan': { label: 'San Juan', cities: {} },
      'San Luis': { label: 'San Luis', cities: {} },
      'Santa Cruz': { label: 'Santa Cruz', cities: {} },
      'Santa Fe': { label: 'Santa Fe', cities: {} },
      'Santiago del Estero': { label: 'Santiago del Estero', cities: {} },
      'Tierra del Fuego': { label: 'Tierra del Fuego', cities: {} },
      Tucumán: { label: 'Tucumán', cities: {} },
    },
  },
  UY: { label: 'Uruguay', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  CL: { label: 'Chile', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  PY: { label: 'Paraguay', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  BO: { label: 'Bolivia', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  BR: { label: 'Brasil', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  ES: { label: 'España', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  IT: { label: 'Italia', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  FR: { label: 'Francia', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  DE: { label: 'Alemania', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  MX: { label: 'México', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
  US: { label: 'Estados Unidos', provinces: { __ANY__: { label: 'Provincia/Estado (opcional)', cities: {} } } },
};

export function tSign(sign) {

  if (!sign) return '—';

  const key = String(sign).trim();

  return (isEnglishPresentation() ? SIGN_EN : SIGN_ES)[key] || key;

}

export function tPlanet(name) {

  if (!name) return isEnglishPresentation() ? 'Planet' : 'Planeta';

  const key = String(name).trim();

  return (isEnglishPresentation() ? PLANET_EN : PLANET_ES)[key] || key;

}

export function planetEmoji(name) {

  if (!name) return '';

  const key = String(name).trim();

  return PLANET_EMOJI[key] || '';

}

export function signEmoji(sign) {

  if (!sign) return '';

  const key = String(sign).trim();

  return SIGN_EMOJI[key] || '';

}

export function formatDegree(value) {

  const num = Number(value);

  if (!Number.isFinite(num)) return '—';

  return `${num.toFixed(2)}°`;

}

export function getDisplayDegree(point) {

  if (!point || typeof point !== 'object') return null;

  const hasNormDegree = point.normDegree !== null
    && point.normDegree !== undefined
    && point.normDegree !== '';
  const normDegree = hasNormDegree ? Number(point.normDegree) : NaN;

  if (Number.isFinite(normDegree) && normDegree >= 0 && normDegree < 30) return normDegree;

  const absolute = point.longitude ?? point.degree;
  if (absolute === null || absolute === undefined || absolute === '') return null;
  const value = Number(absolute);

  if (!Number.isFinite(value)) return null;

  return ((value % 30) + 30) % 30;

}

export function formatRetro(isRetro) {

  if (isRetro === true || isRetro === 'true' || isRetro === 'True') {

    return isEnglishPresentation() ? 'Retrograde' : 'Retrógrado';

  }

  return isEnglishPresentation() ? 'Direct' : 'Directo';

}

export function houseLabel(house) {

  if (!Number.isFinite(Number(house))) return `${isEnglishPresentation() ? 'House' : 'Casa'}\u202F—`;

  const h = Number(house);

  const emoji = HOUSE_EMOJI[h] || '🏠';

  return `${emoji}\u202F${isEnglishPresentation() ? 'House' : 'Casa'}\u202F${h}`;

}
